import React, { createContext, useContext } from 'react';

// 1. Create the context with a default value of `false` (not disabled).
const AuthDisabledContext = createContext(false);

// 2. Export the provider so our Protected component can use it.
export const AuthDisabledProvider = AuthDisabledContext.Provider;

// 3. Create the custom hook that all your components will use.
// It's simple, clean, and declarative.
export const useAuthDisabled = () => {
    return useContext(AuthDisabledContext);
};

export const ProtectedFieldSet = ({ children }) => {
    const isDisabled = useAuthDisabled();
    // The native <fieldset disabled> attribute automatically disables all descendant form inputs.
    return <fieldset disabled={isDisabled} style={{ border: 'none', padding: 0, margin: 0 }}>{children}</fieldset>;
};